module.exports = __webpack_public_path__ + "media/dobry_wzor/polub-nas-img@2x-4d3e7aee.png";